import { Controller } from "@hotwired/stimulus"

// Lazy YouTube facade: shows a poster + play button and only loads the
// privacy-enhanced (youtube-nocookie) iframe on click. Keeps the page light
// and sets no YouTube cookies for visitors who never play. Tracks the first
// play via ahoy so demo play-rate stays in the funnel.
export default class extends Controller {
  static values = { id: String, label: String, title: String }

  load() {
    if (this.loaded) return
    this.loaded = true

    const iframe = document.createElement("iframe")
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.idValue}?autoplay=1&rel=0&modestbranding=1&playsinline=1`
    iframe.title = this.titleValue || "Video"
    iframe.className = "absolute inset-0 w-full h-full"
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    iframe.allowFullscreen = true
    iframe.setAttribute("frameborder", "0")

    this.element.replaceChildren(iframe)

    if (window.ahoy) {
      ahoy.track("video_play", { label: this.labelValue || "video" })
    }
  }
}
